import React from 'react';

const PrintRmJb = ({ values, penilaian, id, print }) => {
  return (
    <button
      disabled={ !penilaian.data }
      className='btn btn-success'
      onClick={ () => print(id, values.type) }>
      Cetak Sertifikat
    </button>
  );
};

const PrintRmJbEdit = ({ values, penilaian, id, printEdit }) => {
  return (
    <button
      disabled={ !penilaian.data }
      className='btn btn-info'
      onClick={ () => printEdit(id, values.type) }>
      edit
    </button>
  );
};

export default PrintRmJb;
export {PrintRmJbEdit};
